import axios from "@util/axios";
import { trackPromise } from "react-promise-tracker";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const sendFile = async (file) => {
   return axios({
      method: "post",
      url: `${hostCloud}/file`,
      headers: {
         Accept: "*/*",
         "Content-Type": "multipart/form-data"
      },
      data: file
   });
};

export const sendFormFile = async (file, fieldId) => {
   return axios({
      method: "post",
      url: `${hostCloud}/legacy/file/form?formFieldId=${fieldId}`,
      headers: {
         Accept: "*/*",
         "Content-Type": "multipart/form-data"
      },
      data: file
   });
};

export const sendAvatar = async (fileId) => {
   return axios({
      method: "post",
      url: `${hostCloud}/user-avatar?fileId=${fileId}`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const deleteFile = async (fileId) => {
   return await trackPromise(
      axios({
         method: "delete",
         url: `${hostCloud}/file?fileId=${fileId}`,
         headers: {
            Accept: "*/*"
         }
      })
   );
};

export const getFile = async (fileId) => {
   return await trackPromise(
      axios({
         method: "get",
         url: `${hostCloud}/file/link?fileId=${fileId}`,
         headers: {
            Accept: "*/*"
         }
      })
   );
};

export const getFileInfo = async (fileId) => {
   return await trackPromise(
      axios({
         method: "get",
         url: `${hostCloud}/file/info?fileId=${fileId}`,
         headers: {
            Accept: "*/*"
         }
      })
   );
};

export const getFileBytes = async (fileId) => {
   return await trackPromise(
      axios({
         method: "get",
         url: `${hostCloud}/file/bytes?fileId=${fileId}`,
         headers: {
            Accept: "*/*"
         }
      })
   );
};

export const getBlob = async (id) => {
   const url = `${hostCloud}/legacy/request`;
   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json"
         },
         data: {
            endpoint: `/files`,
            parameters: `/{\"dtbId\":${id}}`,
            httpMethod: "GET",
            isAuthenticated: true
         }
      }).then((res) => {
         return res;
      })
   );
};

export const sendFileToCloudStorage = async (name, type, base64Img) => {
   const url = `${hostCloud}/legacy/request`;

   const body = {
      name,
      type,
      imgB64Data: base64Img
   };

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      },
      data: {
         endpoint: `/files/method/cloudStorage`,
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body)
      }
   }).then((res) => {
      return res;
   });
};
